import * as React from 'react';

const TwitterIcon = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 35.55 35.54" {...props}>
    <path d="M25.14 13.99c.24 5.35-3.75 11.31-10.8 11.31-2.15 0-4.14-.63-5.83-1.71 2.02.24 4.03-.32 5.63-1.57a3.803 3.803 0 0 1-3.55-2.64c.59.11 1.18.08 1.72-.06-1.83-.37-3.09-2.01-3.05-3.78.51.28 1.1.46 1.72.48a3.82 3.82 0 0 1-1.18-5.08c1.87 2.3 4.68 3.81 7.83 3.97-.55-2.38 1.25-4.67 3.7-4.67 1.09 0 2.08.46 2.78 1.2.87-.17 1.68-.49 2.41-.92-.28.89-.89 1.63-1.67 2.1.77-.09 1.5-.3 2.18-.6-.51.76-1.15 1.43-1.9 1.97Z" />
  </svg>
);

export default TwitterIcon;
